import { useCachedApi } from '@/lib/hooks/use-cached-api';
import { horodatyApi } from '@/lib/utils/horodaty-api';

/**
 * Hook pour récupérer les procédures-types (admin) de la super company
 *
 * @returns {{
 *   templates: Array,
 *   companyName: string | null,
 *   companyTag: string | null,
 *   isLoading: boolean,
 *   error: Error | null,
 *   refetch: (force?: boolean) => Promise<void>,
 *   invalidate: () => void
 * }}
 */
export function useAdminProcedureTemplates() {
    const { data, isLoading, error, refetch, invalidate } = useCachedApi(
        'admin-procedure-templates',
        async () => {
            const response = await horodatyApi.procedureTemplates.listAdmin();
            const responseData = response.data?.data || response.data || {};
            return {
                templates: responseData.templates || [],
                companyName: responseData.company_name || null,
                companyTag: responseData.company_tag || null,
            };
        },
        {
            category: 'procedures',
            initialData: { templates: [], companyName: null, companyTag: null },
        },
    );

    return {
        templates: data?.templates || [],
        companyName: data?.companyName,
        companyTag: data?.companyTag,
        isLoading,
        error,
        refetch,
        invalidate,
    };
}
